export function normalizePhoneNumber(phone: string): string | null {
  if (!phone || typeof phone !== 'string') return null;

  const raw = phone.trim();
  const digits = raw.replace(/\D/g, '');
  if (!digits) return null;

  // Kenya common formats: 0712345678, 712345678, 254712345678
  if (digits.length === 10 && digits.startsWith('0')) {
    return `+254${digits.slice(1)}`;
  }

  if (digits.length === 9 && /^[7-9]\d{8}$/.test(digits)) {
    return `+254${digits}`;
  }

  if (digits.length === 12 && digits.startsWith('254')) {
    return `+${digits}`;
  }

  if (digits.length >= 7 && digits.length <= 15) {
    return `+${digits}`;
  }

  return null;
}

export function hasUsablePhoneNumber(phone: string | null | undefined): boolean {
  if (!phone || typeof phone !== 'string') return false;
  return normalizePhoneNumber(phone) !== null;
}

export function formatPhoneForLink(phone: string): string | null {
  const normalized = normalizePhoneNumber(phone);
  if (!normalized) return null;
  return normalized.replace(/^\+/, '');
}
